import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=781191cf&scoped=true&"
import script from "./Criteria.vue?vue&type=script&lang=js&"
export * from "./Criteria.vue?vue&type=script&lang=js&"
import style0 from "./Criteria.vue?vue&type=style&index=0&id=781191cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781191cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
